import { Injectable } from '@angular/core';
import { splitAtColon } from '@angular/compiler/src/util';
import { environment } from 'src/environments/environment';
import { AppComponent } from './app.component';

@Injectable({
  providedIn: 'root'
})
export class EnvService {
  baseHRef: string;
  app: AppComponent;
  _extraParams: any;
  constructor() {
    this.baseHRef = environment.baseHref;
  }
  SetApp(app: AppComponent) {
    this.app = app;
  }

  GetEnvParam(param: string): any {
    if (environment.hasOwnProperty(param)) {
      return environment[param];
    }
    return null;
  }

  GetRelPath(path: string, relTo?: string): string {
    relTo = (relTo === undefined) ? this.GetURL() : relTo;
    if (path.substr(0, 1) === '/') {
      path = path.substr(1);

      if (path.indexOf('public') < 0) {
        path = this.IsPublic() ? '/public' + ((path === '') ? '' : '/') + path : '/' + path;
      }
    }
    const loc: Array<string> = relTo.split('/');

    /* if (path.indexOf('http') === 0) {
      if (path.indexOf(environment.baseHref.split('/').slice(2).join('/')) > -1) {
        path = path.replace(environment.baseHref.split('/').slice(2).join('/'), '');
      }
    }
    */
    if (path.indexOf('localhost') > -1) {
      path = path.substring(path.indexOf('localhost'));
      path = '/' + path.split('/').slice(1).join('/');
    }
    if (path.indexOf('ng-dev.app')) {
      path = path.substring(path.indexOf('ng-dev.localtest.me'));
      path = '/' + path.split('/').slice(1).join('/');
    }
    if (path.indexOf(this.baseHRef) > -1) {
      path = path.substr(path.indexOf(this.baseHRef) + this.baseHRef.length);
    }

    return path;
  }
  GetPrevPath(prevCount: number = 1, path?: string): string {
    if (path === undefined) {
      path = document.location.href;
    }
    const pathParts: Array<string> = path.split('/');
    for (let ctr = 0; ctr < prevCount; ctr++) {
      pathParts.pop();
    }
    return this.GetRelPath(pathParts.join('/'));

  }

  GetURL() {
    return environment.baseHref;
    // return document.location.href;
  }
  IsPublic() {
    return this.GetRelPath(document.location.href).split('/').indexOf('public') > -1;
  }
  IsSandboxed() {
    return this.GetRelPath(document.location.href).split('/').indexOf('sandboxed') > -1;
  }
  IsDMI() {
    return this.GetRelPath(document.location.href).split('/').indexOf('dmi') > -1;
  }
  private _appName: string = '';
  private _appPath: string = '';
  GetAppNameFromURL(nameOnly = false): string {
    if (nameOnly && this._appName !== '') {
      return this._appName;
    } else if (!nameOnly && this._appPath !== '') {
      return this._appPath;
    }
    const path = this.GetRelPath(document.location.href).split('/');
    if (this.IsPublic()) {
      this._appName = path[1];
      if (nameOnly === true) return path[1];
      if (path.length > 1) {
        this._appPath = 'public' + '/' + path[1];
        return this._appPath;
      }
      return '';
    } else if (this.IsDMI()) {
      this._appName = path[1];
      if (nameOnly === true) return path[1];
      if (path.length > 1) {
        this._appPath = 'dmi' + '/' + path[1];
        return this._appPath;
      }
      return '';
    } else {
      if (path.length > 0) {
        return path[0];
      }
      return '';
    }
  }
  private _fullURL: string = '';
  GetAppURL(): string {
    if (this._fullURL !== '') {
      return this._fullURL;
    }
    this._fullURL = environment.completeURL + this.GetAppNameFromURL() + '/';
    return this._fullURL;
  }
  AwesomeCheck() {
    const doc: HTMLDocument = window.document;
    const fonts = 'fonts';
    if (doc[fonts]) {
      let done = false;
      let match = false;
      const faFamilies = ['Font Awesome 5 Free', 'Font Awesome 6 Free', 'Font Awesome 6 Brands'];
      doc[fonts].forEach((fontFace) => {
        if (done === true) {
          return;
        }
        let family = fontFace.family;
        family = family.replace('\'', '');
        family = family.replace('\'', '');
        family = family.replace('"', '');
        family = family.replace('"', '');


        if (faFamilies.indexOf(family) > -1) {
          done = true;
          match = true;
          return;
        }
      });

      if (match === false) {
        window.requestAnimationFrame(this.AwesomeCheck.bind(this));

      } else {
        this.ShowAwesomeness();
      }
    } else {
      this.ShowAwesomeness();
    }

  }
  ShowAwesomeness() {
    setTimeout(() => {
      document.body.classList.toggle('awesomeless', false);
    }, 2500);
  }
  GetPosition(element: HTMLElement): { left: number, top: number } {
    const clientRect: any = element.getBoundingClientRect();
    return {
      left: clientRect.left + document.body.scrollLeft,
      top: clientRect.top + document.body.scrollTop
    };
  }
  SetExtraParams(params: any) {
    this._extraParams = params;
  }
  GetExtraParams(): any {
    return this._extraParams;
  }

}
